import React, { createContext, useEffect, useState } from "react";
import { DecodeJWT } from "utils/helpers";

export const UserDataContext = createContext();

export const UserDataProvider = (props) => {
    const [token, setToken] = useState(
        localStorage.getItem("access_token")
            ? JSON.parse(localStorage.getItem("access_token"))
            : null
    );
    const [userData, setUserData] = useState();
    useEffect(() => {
        const decoded_token = DecodeJWT(token);

        setUserData({
            hasToken: Boolean(token),
            name: decoded_token?.name,
            role: decoded_token?.roles,
            phone: decoded_token?.phone,
            hub_id: decoded_token?.hub_id,
            vendor_id: decoded_token?.vendor_id,
            branch_id: decoded_token?.branch_id,
            editSections: decoded_token?.sections["edit"],
            menuSections: decoded_token?.sections,
        });
    }, [token]);

    return (
        <UserDataContext.Provider value={[userData, setToken]}>
            {props.children}
        </UserDataContext.Provider>
    );
};
